import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface AdminPolicyConfig {
    adminPolicyApiPath: string;
    requiredAdminPolicies: Set<string>;
    cacheKey: string;
}

@Injectable({
    providedIn: 'root'
})
export class AdminPolicyConfigService {
    public readonly config: AdminPolicyConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<AdminPolicyConfig>('adminPolicyConfig');
    }
}
